import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {InputMask} from "primereact/inputmask";
import {Calendar} from "primereact/calendar";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import moment from "moment/moment";

const CompilanceFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    valid_until: new Date()
  });
  const [newFormData, setNewFormData] = useState({});
  const [employees, setEmployees] = useState([]);
  const [categories, setCategories] = useState([]);
  const selectedCategory = categories.find(c =>
    c.id === (
      Number(window.App.urlVars().categoryId) || formData.category?.id || formData.category
    )
  );

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const payload = {
      ...data,
      employee: Number(window.App.urlVars().employeeId) || data.employee,
      category: Number(window.App.urlVars().categoryId) || data.category,
    };
    if (!selectedCategory?.has_validity) {
      delete payload.valid_until;
    }
    if ((window.App.urlVars().compilanceId) || (entity === 'compilance' && id)) {
      apiCall('patch', '/api/v2/employee-compliance/' + (window.App.urlVars().compilanceId ?? id), {
        ...newFormData,
        employee: Number(window.App.urlVars().employeeId) || newFormData.employee,
        category: Number(window.App.urlVars().categoryId) || newFormData.category,
      })
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCompilanceList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/employee-compliance', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCompilanceList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/hr/compilance/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    let _emloyeeQuery = {
      rows: 9999
    }
    let emloyeeQuery = window.App.transformQueryParams(_emloyeeQuery)
    apiCall('get', '/api/v2/employee' + emloyeeQuery)
      .then(response => {
        setEmployees(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/employee-compliance-category')
      .then(response => {
        setCategories(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if(entity === 'employee' && id) {
      setFormData({
        ...formData,
        employee: Number(id),
      })
    }
    if ((!window.App.urlVars().create && window.App.urlVars().compilanceId) || (entity === 'compilance' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/employee-compliance/' + (window.App.urlVars().compilanceId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"compilance-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            {selectedCategory?.has_validity && (
            <div className={"p-col-12 p-lg-4"}>
              <Field name="valid_until" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="valid_until"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldValidUntil')}</label>
                  <div className="p-inputgroup calendar-icon-only">
                    <InputMask id={"valid_until"}
                               mask={"9999-99-99"}
                               placeholder={t('datePlaceholder')}
                               value={moment.utc(formData.valid_until).local().format('YYYY-MM-DD')}
                               onChange={(e) => {
                                 if (e.value.indexOf("_") === -1) {
                                   if (e.value === '') {
                                     e.value = null
                                   }
                                   setFormData({
                                     ...formData,
                                     valid_until: new Date(e.value)
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     valid_until: new Date(e.value)
                                   })
                                 }
                               }}
                    />
                    <Calendar value={formData.valid_until}
                              locale="hu"
                              dateFormat={'yy-mm-dd'}
                              showIcon
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  valid_until: moment(e.value).endOf('day').format('YYYY-MM-DD')
                                })
                                setNewFormData({
                                  ...newFormData,
                                  valid_until: moment(e.value).endOf('day').format('YYYY-MM-DD')
                                })
                              }}/>
                  </div>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            )}
            
            <div className={"p-col-12 p-lg-8"}>
              <Field name="note" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="note"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldNote')}</label>
                  <span className="p-d-block">
                      <InputText id="note" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     note: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     note: e.target.value
                                   })
                                 }}
                                 value={formData.note}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {entity !== 'employee' && (
            <div className={"p-col-12 p-lg-6"}>
              <Field name="employee" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="employee"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('employee')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(employees, "name")}
                               id={"employee"}
                               disabled={window.App.urlVars().employeeId}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noEmployeeYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   employee: e.value
                                 })
                                 setNewFormData({
                                   ...newFormData,
                                   employee: e.value
                                 })
                               }}
                               filter
                               value={Number(window.App.urlVars().employeeId) || formData.employee?.id || formData.employee}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            )}
            {entity !== 'employee' && (
            <div className={"p-col-12 p-lg-6"}>
              <Field name="category" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="category"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCategory')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(categories, "name")}
                               id={"category"}
                               disabled={window.App.urlVars().categoryId}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noCategoryYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   category: e.value
                                 })
                                 setNewFormData({
                                   ...newFormData,
                                   category: e.value
                                 })
                               }}
                               value={Number(window.App.urlVars().categoryId) || formData.category?.id || formData.category}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            )}
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'compilance' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(CompilanceFormComponent);
